import type { Components, Theme } from '@mui/material'
import typography from 'assets/theme/base/typography'

const { size, fontWeightRegular } = typography

const stepLabel: Components<Omit<Theme, 'components'>>['MuiStepLabel'] = {
  styleOverrides: {
    label: {
      fontWeight: fontWeightRegular,
      fontSize: size.sm,
      color: '#9fc9ff',
      textTransform: 'uppercase',
    },
  },
}

export default stepLabel
